import { render, staticRenderFns } from "./sub-image-title.vue?vue&type=template&id=02895c54&scoped=true"
import script from "./sub-image-title.vue?vue&type=script&lang=js"
export * from "./sub-image-title.vue?vue&type=script&lang=js"
import style0 from "./sub-image-title.vue?vue&type=style&index=0&id=02895c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02895c54",
  null
  
)

export default component.exports